module.exports = __webpack_public_path__ + "img/slotmachine.bc23c418.png";